import { toast } from '@/components/Toast'
const onlineClick = {
  bind: function(el, binding, vnode, oldVnode) {
    function clickHandler(e) {
      if (!navigator.onLine) {
        toast('无网络连接')
        return false
      }
      // 判断指令中是否绑定了函数
      if (binding.expression) {
        // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
        binding.value(binding.arg)
      }
    }
    // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
    el.__vueClickOutside__ = clickHandler
    el.addEventListener('click', clickHandler)
  },
  unbind(el, binding) {
    // 解除事件监听
    document.removeEventListener('click', el.__vueClickOutside__)
    delete el.__vueClickOutside__
  },
  install: (Vue) => Vue.directive('OnlineClick', onlineClick)
}
export default onlineClick
